import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './landingpage.css';
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Avatar } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import { LANDINGPAGE, MASTERIMAGES } from '../../../../../commons/api';
import LayoutAction from '../../../../../modules/actions/LayoutAction';
import { bindActionCreators } from 'redux';

const EquipmentOverview = ({ navigate,setMenuSelection }) => {
  const [deviceList, setDeviceList] = useState({});
  const [requestDeviceCheck, setRequestDeviceCheck] = useState(true);
  const dispatch = useDispatch();

  const colStyle = {
    margin: '5px',
    padding: '5px',
    borderRadius: '10px',
    boxShadow: '5px 5px 30px #333333'
  };
  const titleStyle = {
    fontWeight: 'bold',
    textAlign: 'center',
    borderBottom: '2px dotted black',
    marginBottom: '10px'
  };
  const avatarStyle = {
    height: '50px',
    width: '50px'
  };
  const statusStyle = {
    color:'white',
    paddingLeft: '5px',
    fontWeight: 'bold'
  };
  const _getdeviceList = () => {
    setRequestDeviceCheck(false);
    let siteId = localStorage.get('currentSite') || 'test';
    let accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'POST',
      url: `${LANDINGPAGE.LandingPageCount}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Type: 'Crane'
      }
    };

    axios(headers)
      .then((response) => {
        if (response.data) {
          setDeviceList(response.data);
          setRequestDeviceCheck(true);
        }
      })
      .catch(() => {
        return {};
      });
  };

  const onCraneImageClick = (craneObject, moduleName) => {
    const moduleRoutes = {
      'MHC': ['Modules', '1218', '1220'],
      'QC SVG': ['Modules', '1136', '1138'],
      'RTG': ['Modules', '1144', '1146']
    };

    if (moduleName && moduleRoutes[moduleName]) {
      dispatch(setMenuSelection(moduleRoutes[moduleName]));
    }
    
    navigate(craneObject);
  };

  useEffect(() => {
    let timeTicket = setInterval(() => {
      if (requestDeviceCheck) {
        _getdeviceList();
      }
    }, 1 * 60000);

    _getdeviceList();

    return () => {
      clearInterval(timeTicket);
    };
  }, [requestDeviceCheck]);

  // Render methods remain largely the same as in the class component
  return (
    <div style={{ minHeight: window.innerHeight - 67 }}>
        <div>
          <Row
            style={{
              padding: '10px',
              marginBottom: '10px',
            }}
          >
            <Col span={3} idleset={2}></Col>
            <Col span={5}>
              <Avatar
                shape="square"
                src={`${MASTERIMAGES.MHC_RUNNING_V1_PNG}`}
                style={avatarStyle}
              />
              <span style={statusStyle}>RUNNING</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.MHC_IDLE_V1_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>IDLE</span>
            </Col>
            <Col span={5}>
              <Avatar
                shape="square"
                src={`${MASTERIMAGES.Moblie_Harbour_Crane_V3_PNG}`}
                style={avatarStyle}
              />
              <span style={statusStyle}>STOPPED</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.MHC_Alert_V1_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>DAMAGED/ALERT</span>
            </Col>
          </Row>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {deviceList &&
              deviceList &&
              Array.isArray(deviceList) &&
              deviceList[0].ListOfDevices.map((device, index) => {
                return (
                  <Col
                    key={index}
                    className="colRunning"
                    style={{
                      ...colStyle,
                      backgroundColor: device && device.color ? device.color : '',
                      width: '9%'
                    }}
                    onClick={() => {
                      if (device && device.deviceCode && device.deviceCode === 'MHC-1') {
                        onCraneImageClick(
                          `/rubus/HMI/distinct/MHC/${device.deviceCode}`,
                          'MHC'
                        );
                      } else if (device && device.deviceCode && device.deviceCode === 'MHC2') {
                        onCraneImageClick(
                          `/rubus/HMI/distinct/MHC2/${device.deviceCode}`,
                          'MHC'
                        );
                      } else if (device && device.deviceCode && device.deviceCode === 'MHC3') {
                        onCraneImageClick(
                          `/rubus/HMI/distinct/MHC3/${device.deviceCode}`,
                          'MHC'
                        );
                      }
                    }}
                    width={'7%'}
                  >
                    <div style={titleStyle}>{device.deviceCode} </div>
                    <div
                      className={'stop123'}
                      style={{ backgroundImage: device && device.url ? `url(${device.url})` : '' }}
                    ></div>
                  </Col>
                );
              })}
          </div>
        </div>
        <div>
          <Row
            style={{
              padding: '10px',
              marginBottom: '10px',
            }}
          >
            <Col span={3} idleset={2}></Col>
            <Col span={5}>
              <Avatar
                shape="square"
                src={`${MASTERIMAGES.QC_RUNNING_V3_PNG}`}
                style={avatarStyle}
              />
              <span style={statusStyle}>RUNNING</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.QC_IDLE_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>IDLE</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.QC1_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>STOPPED</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.QC1_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>DAMAGED/ALERT</span>
            </Col>
          </Row>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {deviceList &&
              deviceList &&
              Array.isArray(deviceList) &&
              deviceList[1].ListOfDevices.map((key, index) => {
                return (
                  <Col
                    key={index}
                    className="colRunning"
                    style={{
                      ...colStyle,
                      backgroundColor: key && key.color ? key.color : '',
                      width: '9%'
                    }}
                    onClick={() => onCraneImageClick('/rubus/HMI/static/QC SVG', 'QC SVG')}
                    width={'7%'}
                  >
                    <div style={titleStyle}>{key.deviceCode} </div>
                    <div
                      className={'stop123'}
                      style={{ backgroundImage: key && key.url ? `url(${key.url})` : '' }}
                    ></div>
                  </Col>
                );
              })}
          </div>
        </div>

        <div>
          <Row
            style={{
              padding: '10px',
              marginBottom: '10px',
            }}
          >
            <Col span={3} idleset={2}></Col>
            <Col span={5}>
              <Avatar
                shape="square"
                src={`${MASTERIMAGES.RTG_RUNNING_V3_PNG}`}
                style={avatarStyle}
              />
              <span style={statusStyle}>RUNNING</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.RTG_Idle_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>IDLE</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.RTG_CRANE_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>STOPPED</span>
            </Col>
            <Col span={5}>
              <Avatar shape="square" src={`${MASTERIMAGES.RTG_Alert_V3_PNG}`} style={avatarStyle} />
              <span style={statusStyle}>DAMAGED/ALERT</span>
            </Col>
          </Row>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {deviceList &&
              deviceList &&
              Array.isArray(deviceList) &&
              deviceList[2] &&
              deviceList[2].ListOfDevices.map((key, index) => {
                return (
                  <Col
                    key={index}
                    className="colRunning"
                    style={{
                      ...colStyle,
                      backgroundColor: key && key.color ? key.color : '',
                      width: '9%'
                    }}
                    onClick={() => onCraneImageClick('/rubus/HMI/static/RTG', 'RTG')}
                    width={'7%'}
                  >
                    <div style={titleStyle}>{key.deviceCode} </div>
                    <div
                      className={'stop123'}
                      style={{ backgroundImage: key && key.url ? `url(${key.url})` : '' }}
                    ></div>
                  </Col>
                );
              })}
          </div>
        </div>
      </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMenuSelection: bindActionCreators(LayoutAction, dispatch)
  };
};

export default connect(mapDispatchToProps)(EquipmentOverview);

